<template>
    <div>

        <div class="tab-pane " id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
            <h3>
                <button type="button" class="btn btn-success  btn-reprint float-right" v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'ProductSearcherMass'})" v-if="hasBackButton==='true'">
                    <i class="fa fa-angle-double-left"></i> {{$t('global.back')}}
                    <!--{{$t('productTabs.sellAsCategory')}}-->
                </button>
                {{$t('productSearcher.title')}}
            </h3>
            <br>
            <div class="row form-group">
                <div class="col col-md-4 extensionLine"><label for="barcode" class=" form-control-label">{{$t('productSearcher.barcode')}}</label>
                </div>
                <div class="col-12 col-md-8">
                    <div class=" input-group">
                        <a class="btn_keyboard input-group-addon" v-on:click="clickToOpenKeyboardBarcode">
                            <div class=" "><i class="fa fa-keyboard-o"></i></div>
                        </a>
                        <InputText style="flex: 1 1 0;" :title="$t('productSearcher.barcode')" id="barcode" class="" className="form-control extrafield w100 d-block" isAccept="true" isChange="true" :hasToKeyboard="hasKeyboard" :value="barcode" v-model="barcode"
                                   placeholder="" dataLayout="t"/>
                        <a class="btn_del_input input-group-addon " data-id="0" v-on:click="clickToClearBarcode">
                            <div class=" "><i class="fa fa-times"></i></div>
                        </a>
                    </div>

                    <!--<div class=" input-group">-->
                    <!---->
                    <!--<a class="btn_keyboard input-group-addon " href="#">-->
                    <!--<div class=" "><i class="fa fa-keyboard-o"></i></div>-->
                    <!--</a>-->
                    <!--<span class="d-none-x ">-->
                    <!--<input type="text" id="x2" name="barcode2" placeholder="" class="keyboard_focus kbtext_keyboard_copy barcode2 ui-keyboard-input" value="" aria-haspopup="true" role="textbox">-->
                    <!--</span>-->
                    <!--<input type="text" id="textinputbarcode" name="barcode" placeholder="" class="form-control del_input keyboard_copy_to">-->
                    <!--<a class="btn_del_input input-group-addon " data-id="0" href="#">-->
                    <!--<div class=" "><i class="fa fa-times"></i></div>-->
                    <!--</a>-->
                    <!--</div>-->
                </div>
            </div>

            <div class="row form-group">
                <div class="col col-md-4 extensionLine"><label for="productname" class=" form-control-label">{{$t('productSearcher.name')}}</label>
                </div>
                <div class="col-12 col-md-8">
                    <div class=" input-group">
                        <a class="btn_keyboard input-group-addon" v-on:click="clickToOpenKeyboardProductname">
                            <div class=" "><i class="fa fa-keyboard-o"></i></div>
                        </a>
                        <InputText style="flex: 1 1 0;" :title="$t('productSearcher.name')" id="productname" class="" className="form-control extrafield w100 d-block" isAccept="true" isChange="true" :hasToKeyboard="hasKeyboard" :value="productname"
                                   v-model="productname" placeholder="" dataLayout="t"/>
                        <a class="btn_del_input input-group-addon " data-id="0" v-on:click="clickToClearProductname">
                            <div class=" "><i class="fa fa-times"></i></div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="row searchResultProductElementContainer elementContainer">

          <span class="elementContainer">
               <template v-for="row in elements">

      <div class="colX" v-if="Number(row.pack) === 1">
        <label :for="'text-inputb' + row.id " :class="' box box-x btn-box elementPack-' + row.pack ">
          <span :class="'iconDefault ' + row.iconclass " :style="'background-color:' + row.iconbgcolor + '; color:' + row.iconfgcolor + ';'"></span><span class="textLabel">{{row.name}}</span>
        </label>
        <InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value', 'type']" hasToKeyboard :id="'text-inputb' + row.id " :data-id="row.id"
                   :value="actElCount" :title="row.name" placeholder="" dataLayout="ndbplus" v-model="xactElCount"/>
        <InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value', 'type']" hasToKeyboard :id="'text-inputb_numb' + row.id " :data-id="row.id"
                   :value="actElCount" :title="row.name" :title2="$t('ProductSearcherMass.multiplier')" placeholder="" dataLayout="nplus" v-model="xactElCount_numb"/>

      </div>





      <div class="colX" v-if="Number(row.pack) >= 2 && Number(row.pack) <= 7">
        <div :class="' box box-x btn-box elementPack-' + row.pack ">
        <label :for="'text-inputb' + row.id " :class="'d-table-cell'">
            <!--:class="' box box-x btn-box elementType-' + row.type "-->
          <span v-if="row.iconclass" :class="'iconDefault ' + row.iconclass " :style="'background-color:' + row.iconbgcolor + '; color:' + row.iconfgcolor + ';'"></span>
          <span v-if="!row.iconclass" style="width: 40px; height: 49px; display: block; background-color: transparent; text-align: center; padding: 6px 0;border-right: 1px solid #ccc; font-size:22px;'"><i
                  class="fa fa-keyboard-o"></i></span>
        </label>

           <span class="textLabel" v-on:click="addPurcaseElement({id:'text-inputb'+row.id, value:'1' })">{{row.name}}
            <span class="count">{{row.count}} <small class="" v-if="!!row.count">{{$t('global.piece')}}</small></span><span class="price"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(row.default_price)}}<small
                       class="">
                <template class="" v-if="Number(row.pack)!==2&&Number(row.pack)!==3&&Number(row.pack)!==4&&Number(row.pack)!==5&&Number(row.pack)!==6&&Number(row.pack)!==7">{{suffix}}</template>
                <template class="" v-if="Number(row.pack)===2">{{suffix}}/{{$t('global.pc')}}</template>
                <template class="" v-if="Number(row.pack)===3">{{suffix}}/{{$t('global.kg')}}</template>
                <template class="" v-if="Number(row.pack)===4">{{suffix}}/{{$t('global.l')}}</template>
                <template class="" v-if="Number(row.pack)===5">{{suffix}}/{{$t('global.m')}}</template>
                <template class="" v-if="Number(row.pack)===6">{{suffix}}/{{$t('global.pack')}}</template>
                <template class="" v-if="Number(row.pack)===7">{{suffix}}/{{$t('global.occasion')}}</template>
            </small>
            </span>
        </span>

       </div>
          <InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value']" hasToKeyboard :id="'text-inputb' + row.id " :data-id="row.id"
                     :value="actElCount" :title="row.name" :title2="getTextForElement(row)" placeholder="" dataLayout="n" v-model="xactElCount"/>
      </div>

    </template>


            <!--<template v-for="row in elements">-->
              <!--<div class="colX">-->
                <!--<label :for="'text-inputc' + row.id " :class="' box box-x btn-box elementPack-' + row.pack ">-->
                  <!--<span :class="'iconDefault iconProduct ' + row.iconclass " :style="'background-color:' + row.iconbgcolor + '; color:' + row.iconfgcolor + ';'"></span><span class="textLabel">{{row.name}}-->
                    <!--<span class="count">{{row.count}} <small class="">{{$t('global.piece')}}</small></span><span class="price"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(row.default_price)}}<small-->
                            <!--class="">{{suffix}}</small></span></span>-->
                <!--</label>-->
                <!--<InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value']" hasToKeyboard :id="'text-inputc' + row.id " :data-id="row.id" :value="actElCount" :title="row.name" placeholder=""-->
                           <!--dataLayout="n" v-model="xactElCount"/>-->
              <!--</div>-->
            <!--</template>-->
          </span>
            </div>

        </div>
    </div>


</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import Api from '@/api/Api';

    export default {
        name: 'productSearcher',
        data() {
            return {
                prefix: "",
                suffix: "",
                productname: "",
                barcode: "",
                hasKeyboard: "false",
                data: {},
                actElCount: "",
                elements: [],
                Helper: Helper,
            };
        },
        computed: {
            xactElCount: {
                get(){
                    //this function will determine what is displayed in the input
                    return this.actElCount;
                },
                set(newVal){
                    const modul = this;
                    //this function will run whenever the input changes
                    console.log(newVal);
                    // nplus dbplus handleInput accept
                    if (newVal && newVal.type && newVal.type === "dbplus") {
                        modul.cachedPrice = newVal.value;
                        modul.openNumb(newVal);
                    } else {
                        modul.addPurcaseElement(newVal);
                    }
                }
            }
            , xactElCount_numb: {
                get(){
                    //this function will determine what is displayed in the input
                    return this.actElCount;
                },
                set(newVal){
                    const modul = this;
                    //this function will run whenever the input changes
                    console.log(newVal);
                    // nplus dbplus handleInput accept
                    newVal.itemPrice = modul.cachedPrice;
//                    newVal.itemSumPrice=modul.cachedPrice;
                    newVal.itemCountnum = newVal.value;
                    if (newVal && newVal.type && newVal.type === "dbplus") {

                    } else {
                        modul.addPurcaseElement(newVal);
                    }
                }
            }

//            xactElCount: {
//                get(){
//                    //this function will determine what is displayed in the input
//                    return this.actElCount;
//                },
//                set(newVal){
//                    const modul = this;
//                    //this function will run whenever the input changes
//                    if (newVal.value && !isNaN(Number(newVal.value)) && Number(newVal.value) > 0) {
//                        this.actElCount = newVal.value;
//                        const element = {itemKey: newVal.id.replace("text-input", ""), itemValue: newVal.value};
//                        modul.getElementById(function (err, rows) {
//                            if (rows && rows.length === 1) {
////                            // termék listához
//                                try {
//                                    const dbElement = rows[0];
//                                    element.itemPrice=Number(dbElement.default_price);
//                                    element.itemCountnum=Number(newVal.value);
//                                    element.itemSumPrice=Number(newVal.value)*Number(dbElement.default_price);
//                                    modul.$eventBus.$emit('globalAddPurcaseElement', element);
//                                }
//                                catch (err) {
//                                    console.log("catched error - globalAddPurcaseElement");
//                                }
//                            }
//                        }, Number(element.itemKey));
//                    }
//                    setTimeout(function (e) {
//                        modul.actElCount = "";
//                    }, 0)
//                }
//            }
        },
        props: {
            hasBackButton: String,
        },
        watch: {
            productname: function (newValue, oldValue) {
                const modul = this;
                modul.hasKeyboard = "false";
                modul.searchProductname(newValue);
            },
            barcode: function (newValue, oldValue) {
                const modul = this;
                modul.hasKeyboard = "false";
                if (modul.timer) {
                    clearTimeout(modul.timer);
                }
                modul.timer = setTimeout(function () {
                    if (newValue && newValue !== oldValue) {
                        modul.barcode = modul.barcode.replace(/ö/g, '0');
                    }
                }, 300);
                modul.searchBarcode(newValue);
            },
        },
        mounted() {
            const modul = this;
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
        },
        beforeDestroy() {
        },
        methods: {
            openNumb: function (newVal) {
                const modul = this;
                const itemKey = Number(newVal.id.replace("text-inputb", ""));
                setTimeout(function (e) {
//                    modul.actElCount = "";
//                    setTimeout(function (e) {
                    const el = document.querySelectorAll("#text-inputb_numb" + itemKey)[0];
                    if (el) {
                        el.focus();
                    }
//                    }, 0)
                }, 0)
                console.log(newVal);
            },
            getTextForElement: function (row) {
                const modul = this;
                let retText = "";
                if (row && Number(row.pack) === 2) {
                    retText = " (" + modul.$t('global.pc') + ")"
                }
                if (row && Number(row.pack) === 3) {
                    retText = " (" + modul.$t('global.kg') + ")"
                }
                if (row && Number(row.pack) === 4) {
                    retText = " (" + modul.$t('global.l') + ")"
                }
                if (row && Number(row.pack) === 5) {
                    retText = " (" + modul.$t('global.m') + ")"
                }
                if (row && Number(row.pack) === 6) {
                    retText = " (" + modul.$t('global.pack') + ")"
                }
                if (row && Number(row.pack) === 7) {
                    retText = " (" + modul.$t('global.occasion') + ")"
                }
                return retText;
            },
            addPurcaseElement: function (newVal) {
                const modul = this;
                if (newVal.value && !isNaN(Number(newVal.value)) && Number(newVal.value) !== 0) {
                    this.actElCount = newVal.value;
                    const itemKey = Number(newVal.id.replace("text-inputb", "").replace("_numb", ""));
                    /*                    Wexford
                     itemPrice
                     itemCountnum*/
                    modul.getElementById(function (err, rows) {
                        if (rows && rows.length === 1) {
                            console.log(rows);
                            let itemValue = Number(newVal.value);
                            if (rows && rows[0]) {
                                const dbElement = rows[0];
                                const pack = Number(dbElement.pack);
                                if (pack === 2 || pack === 6 || pack === 7) { // int
                                    itemValue = Helper.getRoundedNumber(itemValue, 0) // int
                                } else if (pack === 1 || pack === 3 || pack === 4 || pack === 5) {
                                    itemValue = Helper.getRoundedNumber(itemValue, 3) // double
                                }
//                                const itemVat = Number(dbElement.vat);
                                let itemPrice = "";
                                let itemSumPrice = "";
                                let itemCountnum = "";
                                if (newVal.itemPrice && newVal.itemCountnum) {
                                    itemPrice = Number(newVal.itemPrice);
                                    itemCountnum = Number(newVal.itemCountnum);
                                    itemSumPrice = Number(newVal.itemPrice) * Number(newVal.itemCountnum);
                                } else if (pack === 1) {
                                    itemPrice = Number(itemValue);
                                    itemSumPrice = Number(itemValue);
                                    itemCountnum = 1;
                                } else {
                                    itemPrice = Number(dbElement.default_price);
                                    itemCountnum = itemValue;
                                    itemSumPrice = Number(itemValue) * Number(dbElement.default_price);
                                }
                                modul.cachedPrice = "";
                                //                            // termék listához
                                if (itemValue !== 0) {
                                    try {
                                        const element = {itemKey: itemKey, itemValue: itemValue, itemPrice: itemPrice, itemCountnum: itemCountnum, itemSumPrice: itemSumPrice}; // , itemVat: itemVat
                                        modul.$eventBus.$emit('globalAddPurcaseElement', element);
                                    }
                                    catch (err) {
                                        console.log("catched error - globalAddPurcaseElement");
                                    }
                                }
                            }
                        }
                    }, Number(itemKey));
                }
                setTimeout(function (e) {
                    modul.actElCount = "";
                }, 0)
            },

            clickToOpenKeyboardProductname(e){
                const modul = this;
                e.preventDefault();
                modul.hasKeyboard = "true";
                setTimeout(function (e) {
                    document.getElementById('productname').focus();
                }, 200);
            },
            clickToClearProductname(e){
                const modul = this;
                modul.productname = "-";
                setTimeout(function (e) {
                    modul.productname = "";
                }, 0);
                e.preventDefault();
            },
            clickToOpenKeyboardBarcode(e){
                const modul = this;
                e.preventDefault();
                modul.hasKeyboard = "true";
                setTimeout(function (e) {
                    document.getElementById('barcode').focus();
                }, 200);
            },
            clickToClearBarcode(){
                const modul = this;
                modul.barcode = "-";
                setTimeout(function (e) {
                    modul.barcode = "";
                }, 0);
            },
            searchBarcode(barcode){
                const modul = this;
                const elemzox = function () {
                    if (barcode.length >= 2) {
                        let valChanged = barcode.replace(/ö/g, '0');
                        modul.getElementByBarcode(function ( res) {
                            if (res && res[0]) {
                                let elements = res; //this.elements;
                                if (Array.isArray(elements)) {
                                    modul.elements = elements;
                                }
                            } else {
                                modul.elements = [];
                            }
                        }, valChanged)
                    } else { //  || barcode === ""
                        modul.elements = [];
                    }
                };
                clearTimeout(window.pressedKeysTimeout2);
                window.pressedKeysTimeout2 = setTimeout(elemzox, 500);
            },

            searchProductname(productname){
                const modul = this;
                const elemzox = function () {
                    if (productname.length >= 2) {
                        modul.getElementByText(function (res) {
                            if (res && res[0]) {
                                let elements = res; //this.elements;
                                if (Array.isArray(elements)) {
                                    modul.elements = elements;
                                }
                            } else {
                                modul.elements = [];
                            }
                        }, productname)

                    } else { //  || productname===""
                        modul.elements = [];
                    }

                };
                clearTimeout(window.pressedKeysTimeout2);
                window.pressedKeysTimeout2 = setTimeout(elemzox, 500);
            },


          getElementByBarcode: function (cb, barcode) {
            const modul = this;
            const data = {};
            data.id = barcode;
            Api.getElementByBarcode(data).then(function (res) {
              if (res && res.result) {
                cb(res.data);
              }
            });
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        cb(err, arrRes)
//                    }
//                    , "element left join stock on stock.id_element=element.id", "element.*, stock.`count` `count`", "barcode=" + window.db.quote(barcode) + " AND  (`element`.`deleted` = 0 OR `element`.`deleted` = '0') ", " name asc", "80");
          },
          getElementByText: function (cb, text) {
            const modul = this;
            const data = {};
            data.text = text;
            Api.getElementByText(data).then(function (res) {
              if (res && res.result) {
                cb(res.data);
              }
            });

//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        cb(err, arrRes)
//                    }
//                    , "element  left join stock on stock.id_element=element.id", "element.*, stock.`count` `count`", "name like " + window.db.quote("%" + text + "%") + " AND (`element`.`deleted` = 0 OR `element`.`deleted` = '0') ", " name asc", "80");
          },


//            clicktofn(e){
////                console.log("clicktofn");
////                const modul = this;
////                e.preventDefault();
////                console.log("clicktofn clicked");
//            },


//            getSell: function (cb, id) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell left join buyer on buyer.id = sell.id_buyer", "*, concat(pre_name, ' ',first_name, ' ',last_name) buyertext, sell.id id", "sell.id=" + id);
//            },
//            getLastSellId: function (cb, id) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell ", "id", "1", "id desc", "1");
//            },
//            getElementTypes: function (cb) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    // TODO left join for stock
//                    , "element ", "type", "deleted = 0 group by type");
//            },
//            getElementCategories: function (cb, id) {
//                const model = this;
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
//                                Array.prototype.forEach.call(arrRes, function (e, i) {
//                                    // TODO - need filter by id, and drop the previeusly
//                                    model.cachedCategories.push(e);
//                                })
//                            }
//                        }
//                        cb(err, arrRes)
//
//                    }
//                    , "element_category", "*", "deleted = 0 and parent_id=" + id, " name asc");
//            },
//            getElementByCategoryId: function (cb, id, type = null) {
//                const model = this;
//                let stringType = "";
//                if (type !== null) {
//                    stringType = " and type = " + Number(type) + " ";
//                }
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
//                                Array.prototype.forEach.call(arrRes, function (e, i) {
//                                    model.purcaseBarcodeItems.push(e);
//                                })
//                            }
//                        }
//                        cb(err, arrRes)
//                    }
//                    // TODO left join for stock
//                    , "element left join stock on stock.id_element=element.id", "element.*, stock.count count", "deleted = 0 and parent_id=" + id + stringType, " name asc");
//            },
//
//            // --------------------------------
//
//            /**
//             * Amikor üres formból indulunk ki - elements lekérdezés
//             * @param cb
//             */
//            getElements: function (cb) {
//                window.db.select(function (err, res) {
//                    cb(err, window.db.convertResToArray(err, res))
//                }, "element", "*", "(`deleted` = 0 OR `deleted` = '0') AND (`type` = 1 OR `type` = '1')", "priority desc, name asc", "800");
//            },
//            /**
//             * Amikor üres formból indulunk ki - elements lekérdezés
//             * @param cb
//             */
//            getElementsType1: function (cb) {
//                window.db.select(function (err, res) {
//                    cb(err, window.db.convertResToArray(err, res))
//                }, "element", "*", "(`deleted` = 0 OR `deleted` = '0') AND  (`parent_id` = 0 OR `parent_id` = '0')", "priority desc, name asc");
//            },
//
////            purcaseBarcodeItems: [],
            getElementById: function (cb, id) {
                const model = this;
                window.db.select(
                    function (err, res) {
                        let arrRes = window.db.convertResToArray(err, res);

                        cb(err, arrRes)
                    }
                    , "element", "*", "id=" + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0') "); //  AND type = 2
            },

//            getElementsByBarcodes: function (cb, barcodes) {
//                const model = this;
//                let strBarcodes = null;
//                if (Array.isArray(barcodes)) {
//                    let arrbk = [];
//                    Array.prototype.forEach.call(barcodes, function () {
//                        arrbk.push(window.db.quote(barcode));
//                    });
//                    strBarcodes = arrbk.join(",");
//                    window.db.select(
//                        function (err, res) {
//                            let arrRes = window.db.convertResToArray(err, res);
//                            if (arrRes && arrRes[0]) {
//                                model.purcaseBarcodeItems.push(arrRes[0]);
//                            }
//                            cb(err, arrRes)
//                        }
//                        , "element", "*", "barcode in (" + strBarcodes + ")");
//                } else {
//                    cb(null, []);
//                }
//            },
//
//            // -----------------------------
//            /**
//             * Hát, ezt át kell hozni
//             */
//            renderPurcaseItems: function () {
//
//            },


        },
        components: {
            InputText,
        },
    };
</script>

<style>

    .d-none-hk {
        width: 1px;
        height: 1px;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
    }

    .vue-touch-keyboard-holder.openKeyboard .d-none-hk {
        width: 100%;
        height: auto;
        opacity: 1;
        position: static;
        /*top: 0;*/
        /*left: 0;*/
    }

</style>

